<kendo-dialog-titlebar (close)="fecheModal()">
  <div class="modal-titlebar">
    <div class="modal-title-icon">
      <i class="fas fa-plus-circle"></i>
    </div>
    <span>Adicionar crédito</span>
  </div>
</kendo-dialog-titlebar>

<div class="credito-modal">
  <div class="cliente-card">
    <div class="cliente-avatar">
      <i class="fas fa-user"></i>
    </div>
    <div class="cliente-info">
      <div class="cliente-topo">
        <h5 class="cliente-nome">{{contato?.nome}}</h5>
        <span class="cliente-badge">Cliente</span>
      </div>
      <div class="cliente-contato">
        <span>{{contato?.telefone || '-'}}</span>
        <i class="fas fa-phone-alt"></i>
      </div>
      <div class="cliente-saldo" *ngIf="contato?.contaFinanceira">
        Crédito disponível:
        <strong>{{contato?.contaFinanceira?.saldo || 0 | currency:'BRL'}}</strong>
      </div>
    </div>
  </div>

  <div class="alert alert-danger mb-3" *ngIf="erro">
    {{erro}}
  </div>

  <div class="secao">
    <label>Valor do crédito</label>
    <kendo-numerictextbox
      [(ngModel)]="dados.valor"
      [min]="0"
      class="valor-input"
      format="c2">
    </kendo-numerictextbox>
  </div>

  <div class="secao">
    <div class="secao-titulo">Forma de pagamento</div>

    <div class="formas-grid">
      <button type="button"
              class="forma-card"
              *ngFor="let forma of formasDePagamento"
              [class.selecionada]="formaSelecionada(forma)"
              (click)="selecioneFormaDePagamento(forma)">
        <div class="forma-icone" [ngClass]="'cor-' + obtenhaCorFormaPagamento(forma)">
          <i class="fas" [ngClass]="obtenhaIconeFormaPagamento(forma)"></i>
        </div>

        <div class="forma-conteudo">
          <div class="forma-titulo">{{obtenhaTituloFormaPagamento(forma)}}</div>
        </div>

        <div class="forma-check" *ngIf="formaSelecionada(forma)">
          <i class="fas fa-check-circle"></i>
        </div>
      </button>
    </div>
  </div>

  <div class="secao">
    <label class="secao-titulo mb-2">Observação</label>
    <textarea class="form-control observacao-input"
              [(ngModel)]="dados.observacao"
              maxlength="300"
              rows="3"
              placeholder="Observação opcional"></textarea>
    <div class="observacao-contador">{{(dados.observacao || '').length}}/300</div>
  </div>

  <div class="acoes">
    <button class="btn btn-cancelar" type="button" (click)="fecheModal()">Cancelar</button>
    <button class="btn btn-confirmar" type="button" (click)="onSubmit()" [disabled]="carregando">
      Confirmar crédito
    </button>
  </div>
</div>
